
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hafa-samband",
      function () {
        return require("private-next-pages/hafa-samband.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hafa-samband"])
      });
    }
  